<section class="container">
	<div class="row py-5">
		<app-atom-reset-password
			class="d-block col-12"
			[code]="params.code"
			[id]="params.id"
		></app-atom-reset-password>
	</div>
</section>
